import { CommonModule } from '@angular/common'
import { InjectionToken, NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { StoreConfig, StoreModule } from '@ngrx/store'
import { ClearwaterTransactionsPanelComponent } from './clearwater-transactions-panel.component'
import { ClearwaterTransactionsGridModule } from './components/clearwater-transactions-grid/clearwater-transactions-grid.module'
import { ClearwaterTransactionsPanelState } from './models/clearwater-transactions-panel-state.model'
import clearwaterTransactionsReducers, {
  clearwaterTransactionsFeatureKey,
} from './state/clearwater-panel-store.reducer'
import { initialPanelState } from './utils/clearwater-transactions-panel-state-utils'

export const FEATURE_CONFIG_TOKEN = new InjectionToken<
  StoreConfig<ClearwaterTransactionsPanelState>
>('Clearwater Transactions')

@NgModule({
  imports: [
    CommonModule,
    ClearwaterTransactionsGridModule,
    GenericComponentsModule,
    StoreModule.forFeature(
      clearwaterTransactionsFeatureKey,
      clearwaterTransactionsReducers,
      FEATURE_CONFIG_TOKEN,
    ),
  ],
  declarations: [ClearwaterTransactionsPanelComponent],
  exports: [ClearwaterTransactionsPanelComponent],
  providers: [
    {
      provide: FEATURE_CONFIG_TOKEN,
      deps: [],
      useFactory: () => ({
        initialState: initialPanelState,
      }),
    },
  ],
})
export class ClearwaterTransactionsPanelModule {}

export { ClearwaterTransactionsPanelComponent }
